var React = require('react');

function AssistappFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.85 48h28.177L35.3 39.972l-20.94-3.99L9.85 48zM48 7.304v28.424L34.25 0h6.446A7.304 7.304 0 0148 7.304zM13.745 0L0 35.875V7.305A7.304 7.304 0 017.304 0h6.441zm2.53 26.45L23.65 5.06l8.387 24.232-15.762-2.842z"}));
}

AssistappFilled.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = AssistappFilled;

AssistappFilled.default = AssistappFilled;
